import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Table from '../Table';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Pagination from '../Pagination';
import userThunk from '../../store/user/userThunk';
import { changeUserFilter, unsetBulkCount } from '../../store/user/userSlice';
import { couponAdminTableHead } from '../../store/code/codeAdminTableHead';

const TableAreaCouponAdmin = () => {
  const userSlice = useAppSelector((state) => state.userSlice);
  const dispatch = useAppDispatch();

  const onChangeFilter = (title: string, value: string | Date | null) => {
    dispatch(changeUserFilter({ title, value }));
  };

  const handleChangePage = (page: number) => {
    dispatch(changeUserFilter({ title: 'page', value: `${page}` }));
  };

  useEffect(() => {
    dispatch(unsetBulkCount());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      try {
        await dispatch(userThunk.getAdminCoupons(userSlice.filter)).unwrap();
      } catch (error) {
        console.error(error);
      }
    })();
  }, [
    dispatch,
    userSlice.filter,
  ]);

  return (
    <Box display="flex" flexDirection="column" rowGap="40px">
      {
        userSlice.addition.isLoading ? (
          <div className="styled-app__loader-mini" />
        ) : (
          <>
            <Table
              filter={userSlice.filter}
              setFilter={onChangeFilter}
              mainArray={userSlice.coupons}
              tableHead={couponAdminTableHead}
            />
            {
              userSlice?.options ? (
                <Pagination
                  currentPage={userSlice?.options.page}
                  totalCount={userSlice?.options.totalPages}
                  pageSize={userSlice?.options.perPage}
                  onPageChange={handleChangePage}
                  countItems={userSlice?.options.totalRecords}
                />
              ) : null
            }
          </>
        )
      }
    </Box>
  );
};

export default TableAreaCouponAdmin;
